import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, useMediaQuery, Box } from '@mui/material';
import { Theme } from '@mui/material/styles';
import CenteredDescription from './CenteredDescription';

interface Props {
  headerSuffix?: string;
  description?: string;
  translationNamespace: string;
  bigHeader?: boolean;
  children?: React.ReactNode;
}

const HeaderWithDescription = ({
  headerSuffix,
  description,
  translationNamespace,
  bigHeader,
  children,
}: Props): JSX.Element => {
  const { t } = useTranslation(translationNamespace);

  const sm = !useMediaQuery((theme: Theme) => theme.breakpoints.up('sm'));

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', p: 2 }}>
      <Typography variant={sm ? (bigHeader ? 'h3' : 'h4') : bigHeader ? 'h2' : 'h3'} sx={{ mb: 1 }} align='center'>
        {t(`header${headerSuffix ? headerSuffix : ''}`)}
      </Typography>
      <CenteredDescription description={description} translationNamespace={translationNamespace} />
      {children !== undefined && children}
    </Box>
  );
};

export default HeaderWithDescription;
